/**
 * @fileoverview This file contains the top contents of the website.
 */
import { Link } from "react-router-dom";
import AtagButton from "../components/AtagButton";

/**
 * Top contents
 * @returns {JSX.Element} ダウンロードページの JSX element
 */
export function Download(): JSX.Element {
  return (
    <div>
      <section className="c-section">
        <h2 className="p-heading-2">CMCD-200ソフトウェア ダウンロード</h2>
        <p className="c-text">
          CMCD-200のロギングデータをパソコンに取り込むためのソフトウェアをダウンロードできます。
          <br />
          <Link to="/cmcd-200/HowToDownload">ダウンロード手順</Link>
          を参考にして、下の[ダウンロード]ボタンを押して、ダウンロードを開始してください。
          <br />
          ダウンロード終了後は、
          <Link to="/cmcd-200/HowToInstallDeviceDriver">
            ドライバーソフトウェアのインストール手順
          </Link>
          を参考にして、ドライバーソフトウェアをインストールします。
        </p>
      </section>

      <AtagButton
        href="https://gastec-public-soft-download.s3.ap-northeast-1.amazonaws.com/cmcd-200/CMCD-200_Software.cab"
        text="ダウンロード"
        download={true}
      />
    </div>
  );
}
